export default __webpack_public_path__ + "static/media/checkup-small.43315103.svg";